export const validateDecimalInput = function (event: KeyboardEvent) {
  const inputChar = String.fromCharCode(event.charCode);
  const currentValue = (event.target as HTMLInputElement).value;

  const isValidChar = /[0-9\.]/.test(inputChar);
  if (!isValidChar) {
    event.preventDefault();
    return;
  }


  if (inputChar === '.' && currentValue.includes('.')) {
    event.preventDefault();
    return;
  }

  const decimalIndex = currentValue.indexOf('.');
  if (decimalIndex >= 0) {
    const decimalPart = currentValue.substring(decimalIndex + 1);
    if (decimalPart.length >= 2 && (event.target as HTMLInputElement).selectionStart! > decimalIndex) {
      event.preventDefault();
    }
  }
}
